import { CancelLoanFeeRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateCancelLoanFee = makeValidator({
  FieldParser: CancelLoanFeeRow,
});
